import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import SearchLink from '../../../containers/searchLinkContainer'
import RemoveIcon from '../../icons/close'

import styles from './filterItem.module.css'

/**
 * A function to render the selected filter link
 * @param  {String} the type of the param, can be category, tags
 * @param  {String} the displayName of the filter
 * @param  {Object} the locationParams
 * @param  {Number} the index of the current option
 * @return {HTML} HTML for the option
 */
const FilterItem = ({
  displayName,
  locationParams,
  index,
  interactive = true
}) => {
  const containerClass = classNames(styles.container, {
    [styles.containerNotInteractive]: !interactive
  })

  const nameContainerClass = classNames(styles.nameContainer, {
    [styles.nameContainerNotInteractive]: !interactive
  })

  const nameClass = classNames(styles.name, {
    [styles.nameNotInteractive]: !interactive
  })

  const SearchLinkWrapper = ({ children }) => (
    <SearchLink
      locationParams={locationParams}
      className={containerClass}
      aria-label={`Remove ${displayName}`}
    >
      {children}
    </SearchLink>
  )

  const DivWrapper = ({ children }) => (
    <div className={containerClass}>{children}</div>
  )

  const Tag = interactive ? SearchLinkWrapper : DivWrapper

  return (
    <li key={index} className={styles.filterListItem}>
      <Tag>
        <div className={nameContainerClass}>
          <span className={nameClass}>{displayName}</span>
        </div>
        {interactive && (
          <span className={styles.removeLink}>
            <RemoveIcon width="8" height="8" className={styles.icon} />
          </span>
        )}
      </Tag>
    </li>
  )
}

FilterItem.propTypes = {
  displayName: PropTypes.string.isRequired,
  locationParams: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  interactive: PropTypes.bool
}

export default FilterItem
